"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethod = void 0;
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["GooglePay"] = "googlePay";
    PaymentMethod["Cash"] = "cash";
    PaymentMethod["POS"] = "pos";
    PaymentMethod["CreditCard"] = "creditCard";
    PaymentMethod["PayPal"] = "payPal";
    PaymentMethod["Venmo"] = "venmo";
    PaymentMethod["PayPalCredit"] = "payPalCredit";
    PaymentMethod["PayPalPayLater"] = "payPalPayLater";
    PaymentMethod["MercadoPago"] = "mercadoPago";
    PaymentMethod["InPerson"] = "inPerson";
    PaymentMethod["PagSeguro"] = "pagSeguro";
    PaymentMethod["IDeal"] = "iDeal";
    PaymentMethod["Sofort"] = "sofort";
    PaymentMethod["Alipay"] = "alipay";
    PaymentMethod["Offline"] = "offline";
    PaymentMethod["FakePaymentMethod"] = "fakePaymentMethod";
    PaymentMethod["ConvenienceStore"] = "convenienceStore";
    PaymentMethod["PayEasy"] = "payEasy";
    PaymentMethod["Privat24"] = "privat24";
    PaymentMethod["UniPay"] = "uniPay";
    PaymentMethod["BitPay"] = "bitPay";
    PaymentMethod["ApplePay"] = "applePay";
    PaymentMethod["Bancontact"] = "bancontact";
    PaymentMethod["Boleto"] = "boleto";
    PaymentMethod["Afterpay"] = "afterpay";
    PaymentMethod["Clearpay"] = "f7da7147-483e-418d-9e7c-b2aa28212729";
    PaymentMethod["Multibanco"] = "multibanco";
    PaymentMethod["Laybuy"] = "laybuy";
    PaymentMethod["CardReader"] = "cardReader";
    PaymentMethod["Affirm"] = "fa75e2c4-1ba3-4cb1-91e0-f28e8c29c629";
    PaymentMethod["Sezzle"] = "f420f6d2-f895-439e-b28e-b9ba90157013";
    PaymentMethod["Atome"] = "ba2678da-3e4f-4da9-910c-17fd64316770";
    PaymentMethod["Pix"] = "pix";
    PaymentMethod["Bit"] = "bit";
    PaymentMethod["PayItMonthly"] = "5981f0d6-edb1-456a-a976-674d5c2b0971";
    PaymentMethod["Razorpay"] = "865f0230-0659-4236-9652-2b0bb53d9e67";
    PaymentMethod["Splitit"] = "18d5fda5-1e84-4ff5-897d-2522861ab846";
    PaymentMethod["CashApp"] = "8f21d60d-fdd8-4ae0-8a52-189c1bc3bd10";
    PaymentMethod["UsBankAccount"] = "usBankAccount";
    PaymentMethod["Link"] = "b45a9f9d-3434-4796-9eed-c5adbf35a8fb";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
//# sourceMappingURL=PaymentMethod.js.map